import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { platformSettingsApi, type UpdatePlatformSettingsRequest } from '../api/client'

export function usePlatformSettings() {
  return useQuery({
    queryKey: ['platform-settings'],
    queryFn: platformSettingsApi.get,
  })
}

export function useUpdatePlatformSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: UpdatePlatformSettingsRequest) => platformSettingsApi.update(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['platform-settings'] })
    },
  })
}
